export const getCookieValueByKey = (key: string) => {
    const regex = new RegExp(`(^| )${key}=([^;]+)`);
    const match = document.cookie.match(regex);
    if (match) {
        return match[2];
    }
    return undefined;
};

export const setCookieByKey = (key: string, value: string) => {
    document.cookie = key + '=' + value;
};

export const isCookieExistByKey = (key: string) => {
    const regex = new RegExp(`(^| )${key}=([^;]+)`);
    const match = document.cookie.match(regex);
    if (match) {
        return true;
    }
    return false;
};

export const clearCookie = () => {
    document.cookie.split(';').forEach(function (c) {
        console.log(c);
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
};
